module.exports = __webpack_public_path__ + "assets/img/hub-eff20674.png";